import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import PageInfoStore from './flux/PageInfoStore';

import useDebounce from './hooks/useDebounce';
import useKeyPress from './hooks/useKeyPress';
import MainNavSearchResults from './MainNavSearchResults';

export default function MainNavSearch() {
  const [selectedMenu, setSelectedMenu] = useState(PageInfoStore.getSelectedSubMenu());
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState(false);
  const [animate, setAnimate] = useState(false);
  const escapeKey = useKeyPress("Escape");
  const inputRef = useRef(null);

  const searchURL = "/search/suggest.json?resources%5Btype%5D=product&resources%5Blimit%5D=4&section_id=predictive-search-json&q=";
  const debouncedSearchTerm = useDebounce(searchTerm, 250);

  useEffect(() => {
    const emitter1 = PageInfoStore.addListener('selectedSubMenu', () => {
      const menu = PageInfoStore.getSelectedSubMenu();
      setSelectedMenu(menu);
      if (menu === 'search') {
        console.log('search just loaded up...');
        setAnimate(true);
        setTimeout(() => {
          console.log(inputRef.current.focus());
          setAnimate(false);
        }, 50);
      }
    });
    return () => { emitter1.remove(); }
  });

  useEffect(() => {
    const emitter3 = PageInfoStore.addListener('searchValue', () => {
      setSearchTerm(PageInfoStore.getSearchTerm());
    });
    return () => { emitter3.remove() }
  });

  useEffect(() => {
    const emitter4 = PageInfoStore.addListener('searchResults', () => {
      setResults(PageInfoStore.getSearchResults());
    });
    return () => { emitter4.remove() }
  });

  useEffect(() => {
    if (debouncedSearchTerm) {
      // console.log(`${searchURL}${debouncedSearchTerm}`);
      axios.get(`${searchURL}${debouncedSearchTerm}`)
        .then((response) => {
          const products = response.data.resources.results.products;
          PageInfoStore.setSearchResults(products);
        })
        .catch((error) => {
          console.log(error);
          PageInfoStore.setSearchResults([]);
        });
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (escapeKey && selectedMenu) {
      PageInfoStore.setSelectedSubMenu(false);
    }
  }, [escapeKey, selectedMenu]);

  // function handleFocus(e) {
  //   console.log(e.target.select());
  // }

  function setUpSearch(inputValue) {
    const inputTrim = inputValue.trim();
    if (inputTrim) {
      PageInfoStore.setSearchTerm(inputValue);
    } else {
      PageInfoStore.setSearchTerm(false);
      PageInfoStore.setSearchResults(false);
    }
  }

  function renderSearch() {
    return (
      <span class={animate ? 'search animate' : 'search'}>
        <div className="header-search-bar">
          <div className="page-width">
            {/* {animate ? 'ANIMATE' : ''} */}
            <form action="/search" method="get" role="search">
              <input 
                // type="search"
	              name="q"
                role="combobox"
                aria-expanded="false"
                aria-owns="predictive-search-results-list"
                aria-controls="predictive-search-results-list"
                aria-haspopup="listbox"
                aria-autocomplete="list"
                autocorrect="off"
                autocomplete="off"
                autocapitalize="off"
                spellcheck="false"
                value={searchTerm ? searchTerm : ''}
                placeholder="Search"
                onChange={((e) => {
                  setUpSearch(e.target.value);
                })}
                onFocus={(e) => {
                  e.target.select()
                }}
                ref={inputRef}
              />

            </form>
            <span
                onClick={() => { 
                  // PageInfoStore.toggleSearchBar();
                  PageInfoStore.setSelectedSubMenu(false);
                }}
                className="close-button"
              >
                <i className="fa-solid fa-xmark"></i>
              </span>
          </div>
        </div>
        {results ? <MainNavSearchResults /> : ''}
      </span>
    )
  }
  
  return selectedMenu === 'search' ? renderSearch() : '';
}